export const WORKER_PATH = 'pushy-service-worker.js?3'
export const APP_ID = import.meta.env.VITE_PUSHYME_APP_ID || ''
